<template>
  <div class="container-fluid">
    <!-- Title -->
    <div class="row flex-row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Income Statement - Fund
        </div>
        <div class="s-14 py-0 text-dak">
          {{ branchItem ? branchItem.parentNames : "" }}
        </div>
      </div>
      <div class="c-pointer">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dark w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  v-if="selectedTab === 'summary'"
                  class="no-decoration text-dark"
                  @click="downloadFile1(bookType)"
                >
                  {{ bookType.name }}
                </a>
                <a
                  v-if="selectedTab === 'summaryAccount'"
                  class="no-decoration text-dark"
                  @click="downloadFile2(bookType)"
                >
                  {{ bookType.name }}
                </a>
                <a
                  v-if="selectedTab === 'details'"
                  class="no-decoration text-dark"
                  @click="downloadFile3(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row bg-gray-300 justify-content-center py-3 border-radius-8">
      <div class="col-md-12 pl-4">
        <div class="row align-items-center">
          <div class="col-md-8 col-12">
            <div class="row align-items-center">
              <div class="col-md-3 col-12">
                <div class="text-md-right text-left s-14 fw-400 text-dak">
                  Date Range
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <!-- <div class="col-md-3 col-12 mt-2 mt-md-1 mb-3 mb-md-0">
                <div class="col-md-12 px-0">
                  <el-select-v2
                    v-model="selectedAccountID"
                    class="w-100 font-weight-normal report-select"
                    :options="
                      accountType.map((i) => ({
                        label: i.name,
                        value: i.id,
                      }))
                    "
                    placeholder="Select Account"
                    @change="setSelectedAccount"
                    size="medium"
                  />
                </div>
              </div> -->
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              class="col-md-12 mt-3 d-flex justify-content-center justify-content-md-end px-0"
            >
              <el-button
                class="c-pointer w-100"
                :color="primarycolor"
                :loading="loading"
                round
                @click="generateReport"
              >
                Generate Report
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="text-center">
          <div class="row justify-content-center">
            <div
              class="col-md-10 d-flex justify-content-between align-items-end"
            >
              <div class="fw-400 s-14 text-dak">
                <span>Income</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(totalIncome).toLocaleString() }}
                </div>
              </div>
              <span>-</span>
              <div class="fw-400 s-14 text-dak">
                <span>Expenses</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(totalExpense).toLocaleString() }}
                </div>
              </div>
              <span>=</span>
              <div class="fw-400 s-14 text-dak">
                <span>Net Balance</span>
                <div
                  :style="{
                    color: diffBtwIncomeAndExpenses < 0 ? 'red' : '#088c35',
                  }"
                  class="s-24 text-head font-weight-600"
                >
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(diffBtwIncomeAndExpenses).toLocaleString() }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="d-flex justify-content-center mt-5 cursor-pointer">
          <div
            style="background: #e0f2ff"
            class="p-1 d-flex align-items-center border-radius-8"
          >
            <div
              v-for="tab in tabs"
              :key="tab.id"
              style="color: #08162e"
              class="s-12 px-3"
              :class="{ active: selectedTab === tab.id }"
              @click="handleTabClick(tab.id)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4" v-if="selectedTab === 'summary'">
      <div
        v-for="(
          fund, index
        ) in incomeStatementData.incomeStatementSummaryByFund"
        :key="index"
        class="col-md-12 border border-radius-8 mt-3"
      >
        <div class="text-center col-md-12 px-0 py-3">
          <div class="row">
            <div
              class="col-md-12 d-flex flex-wrap justify-content-between align-items-end"
            >
              <div>
                <el-button
                  style="width: 125.39px !important; height: 51px !important"
                  color="#D4DDE4"
                  class="text-dak border-radius-8"
                  ><span class="text-dak s-14 fw-500">{{
                    fund.fundName
                  }}</span></el-button
                >
              </div>
              <div class="fw-400 s-14 text-dak">
                <span>Income</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(fund.totalIncome).toLocaleString() }}
                </div>
              </div>
              <span>-</span>
              <div class="fw-400 s-14 text-dak">
                <span>Expenses</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(fund.totalExpense).toLocaleString() }}
                </div>
              </div>
              <span>=</span>
              <div class="fw-400 s-14 text-dak">
                <span>Fund Balance</span>
                <div
                  :style="{
                    color:
                      fund.totalIncome - fund.totalExpense < 0
                        ? 'red'
                        : '#088c35',
                  }"
                  class="s-24 text-head font-weight-600"
                >
                  {{ currentUser.currencySymbol }}
                  {{
                    Math.abs(
                      fund.totalIncome - fund.totalExpense
                    ).toLocaleString()
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="selectedTab === 'summary'">
      <div class="col-md-12 px-0 d-flex flex-wrap">
        <div class="col-md-6">
          <IncomeStatmentColumnChart
            domId="chart1"
            title=""
            distance="5"
            subtitle=""
            :titleMargin="10"
            :data="fundChartData.series"
            :series="fundChartData.categories"
            yAxisText="Amount"
          />
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <IncomeStatementPieChart
            v-if="selectedTab === 'summary'"
            domId="chart"
            title=""
            :summary="pieChartData"
          />
        </div>
      </div>
      <div class="col-md-12 px-0">
        <IncomeStatementFundSummary
          :endDate="endDate"
          :startDate="startDate"
          :bookType="bookTypeItem1"
          :fileHeaderToExport="fileHeaderToExport"
          :fileToExport="fileToExport"
          :fileName="fileName"
          :incomeStatementSummaryData="incomeStatementData"
          @download-complete="handleDownloadComplete"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 px-0" v-if="selectedTab === 'summaryAccount'">
        <IncomeAcctStmentFund
          :bookType="bookTypeItem2"
          :fileHeaderToExport="fileHeaderToExport"
          :fileToExport="fileToExport"
          :fileName="fileName"
          @download-complete="handleDownloadComplete"
          :endDate="endDate"
          :startDate="startDate"
          :incomeStatementSummaryData="incomeStatementData"
        />
      </div>
    </div>

    <!-- Accounts Table -->

    <div
      class="mt-3 row mt-4"
      id="element-to-print"
      v-if="selectedTab === 'details'"
    >
      <div
        class="container-fluild table-main remove-styles2 remove-border responsiveness"
      >
        <div class="row" v-if="bookTypeItem3 == 'pdf'">
          <div
            class="col-md-12 px-0 d-none"
            :class="{ 'd-none': bookTypeItem3 == 'pdf' }"
          >
            <table
              id="table"
              class="table remove-styles mt-0 col-md-12 table-hover table-header-area"
            >
              <thead>
                <tr>
                  <th>
                    <div class="row">
                      <div class="col-md-12 d-flex justify-content-between">
                        <div>
                          <div class="s-20 fw-500">
                            Income Statement - Fund(Profit & Loss)
                          </div>
                          <div class="s-18 font-weight-600">
                            {{ tenantDisplayName }}
                          </div>
                          <div class="s-18 fw-500">
                            <span class="mr-1"> Date Range: </span>
                            <span>
                              {{ formatDate(startDate) }}
                              to {{ formatDate(endDate) }}
                            </span>
                          </div>
                        </div>
                        <div>
                          <img
                            :src="churchLogo"
                            v-if="churchLogo"
                            class="link-image mr-2"
                            alt=""
                          />
                          <img
                            src="../../../assets/dashboardlinks/churchcloud.png"
                            v-else
                            class="link-image mr-2"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div
          class="col-md-12 d-flex justify-content-between align-items-center font-weight-bold s-14 text-dak"
        >
          <div>ACCOUNTS</div>

          <div class="text-right">
            <div class="text-dak s-14">{{ formatDate(startDate) }}</div>
            <div class="text-dak s-14">to {{ formatDate(endDate) }}</div>
          </div>
        </div>
        <div
          class="container-fluild mt-2 table-main remove-styles2 remove-border responsiveness"
        >
          <!-- Loop through each fund -->
          <div
            v-for="(fundData, fundName, index) in fundsData"
            :key="fundName"
            :class="{ 'mt-4': index > 0 }"
            class="fund-section border rounded"
          >
            <div class="s-18 font-weight-600 py-3 ml-2 text-dak">
              {{ fundName }}
            </div>

            <table
             id="table"
              class="table remove-styles mt-0 table-hover table-header-area"
            >
              <tbody>
                <tr class="category-header">
                  <td colspan="3" class="table-header-area-main fw-400 s-14">
                    <div>Income</div>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in fundData.income"
                  :key="`income-${index}`"
                >
                  <td>
                    <div class="font-weight-medium">{{ item.accountName }}</div>
                    <div class="text-muted small">{{ item.description }}</div>
                  </td>
                  <td class="text-left d-flex justify-content-end">
                    {{ formatDate(item.date) }}
                  </td>
                  <td class="text-right">
                    {{ item.currency?.symbol || currentUser.currencySymbol }}
                    {{ formatAmount(item.amount) }}
                  </td>
                </tr>
                <tr class="total-row">
                  <td class="font-weight-bold">Total Income</td>
                  <td></td>
                  <td class="text-right font-weight-bold">
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(fundData.incomeTotal) }}
                  </td>
                </tr>
              </tbody>

              <!-- Expense Section -->
              <tbody>
                <tr class="category-header">
                  <td colspan="3" class="table-header-area-main fw-400 s-14">
                    <div>Expense</div>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in fundData.expense"
                  :key="`expense-${index}`"
                >
                  <td>
                    <div class="font-weight-medium">{{ item.accountName }}</div>
                    <div class="text-muted small">{{ item.description }}</div>
                  </td>
                  <td class="text-left d-flex justify-content-end">
                    {{ formatDate(item.date) }}
                  </td>
                  <td class="text-right">
                    {{ item.currency?.symbol || currentUser.currencySymbol }}
                    {{ formatAmount(Math.abs(item.amount)) }}
                  </td>
                </tr>
                <tr class="total-row">
                  <td class="font-weight-bold">Total Expense</td>
                  <td></td>
                  <td class="text-right font-weight-bold">
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(fundData.expenseTotal) }}
                  </td>
                </tr>
              </tbody>

              <!-- Fund Balance -->
              <tbody>
                <tr class="net-balance-row">
                  <td class="font-weight-bold">Fund Balance</td>
                  <td></td>
                  <td
                    class="text-right font-weight-bold"
                    :style="{ color: fundData.balance < 0 ? 'red' : '#000000' }"
                  >
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(fundData.balance) }}
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr
                  class="table-header-area-main fw-400 s-14"
                  v-if="index === Object.keys(fundsData).length - 1"
                >
                  <td class="font-weight-bold">Net Balance</td>
                  <td></td>
                  <td
                    class="text-right font-weight-bold"
                    :style="{ color: netTotal < 0 ? 'red' : '#000000' }"
                  >
                    {{ currentUser.currencySymbol }}
                    {{ formatAmount(netTotal) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, inject, watchEffect, nextTick } from "vue";
// import exportService from "../../../services/exportFile/exportservice";
import exportService from "../../../services/exportFile/exportserjs";
import IncomeStatementPieChart from "@/components/charts/ReportPieChart.vue";
import IncomeStatmentColumnChart from "../../../components/charts/ReportColumnChart.vue";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import { ElNotification } from "element-plus";
import IncomeStatementFundSummary from "./IncomeStatementFundSummary.vue";
import incomeExpenseHelper from "./Helper/Incomeexpenses-helper.js";
import dateFormatter from "../../../services/dates/dateformatter";
import IncomeAcctStmentFund from "./IncomeAcctStmentFund.vue";

// Date & Filters
// const selectedDate = ref(new Date(Date.now()));
const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
const endDate = ref(new Date(Date.now()));
const loading = ref(false);
const primarycolor = inject("primarycolor");
const tableData = ref({});
const incomeStatementData = ref({});
const bookTypeItem1 = ref("");
const bookTypeItem2 = ref("");
const bookTypeItem3 = ref("");
const incomeStatement = ref([]);
const fileName = ref("Income Statement Fund Report");
const bookTypeList = ref([
  { name: "xlsx" },
  { name: "csv" },
  { name: "txt" },
  { name: "pdf" },
]);
// const selectedFileType = ref({});
const fileHeaderToExport = ref([]);
const fileToExport = ref([]);
const bookTypeItem = ref("");
const showReport = ref(false);
const store = useStore();
const selectedTab = ref("summary");
const chartForIcomeAndExpense = ref([]);
const transactions = ref([]);
const tenantData = ref({});
const churchLogo = ref("");
const branchItem = ref({});
branchItem.value = JSON.parse(localStorage.getItem("branchItem"));

const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};

const tabs = [
  { id: "summary", label: "Summary" },
  { id: "summaryAccount", label: "Account Summary" },
  { id: "details", label: "Details" },
];

const handleTabClick = async (tabId) => {
  selectedTab.value = tabId;

  // Only refresh data when switching to summary tab
  if (
    tabId === "summary" ||
    tabId === "summaryAccount" ||
    tabId === "details"
  ) {
    await getReport();
  }
};

const downloadFile1 = async (item) => {
  if (selectedTab.value === "summary") bookTypeItem1.value = null;
  await nextTick();
  bookTypeItem1.value = item.name;
};
const downloadFile2 = async (item) => {
  if (selectedTab.value === "summaryAccount") bookTypeItem2.value = null;
  await nextTick();
  bookTypeItem2.value = item.name;
};
const downloadFile3 = async (item) => {
  bookTypeItem3.value = item.name;
  await nextTick();
  exportService.downLoadExcel(
    item.name,
    document.getElementById("element-to-print"),
    fileName.value,
    fileHeaderToExport.value,
    fileToExport.value
  );
  ElNotification.success({ message: "Export completed!" });
};
const getChurchProfile = async () => {
  if (branchItem.value && branchItem.value.id) {
    try {
      let { data } = await axios.get(
        `/GetChurchProfileById?tenantId=${branchItem.value.id}`
      );
      churchLogo.value = data.returnObject.logo;
    } catch (err) {
      console.error(err);
    }
  } else {
    try {
      let { data } = await axios.get(
        `/GetChurchProfileById?tenantId=${getUser.value.tenantId}`
      );
      churchLogo.value = data.returnObject.logo;
    } catch (err) {
      console.error(err);
    }
  }
};
const getUser = computed(() => {
  if (
    !store.getters.currentUser ||
    (store.getters.currentUser &&
      Object.keys(store.getters.currentUser).length == 0)
  )
    return "";
  return store.getters.currentUser;
});
watchEffect(() => {
  if (getUser.value) {
    tenantData.value = getUser.value;
    getChurchProfile();
  }
});
const handleDownloadComplete = (success) => {
  if (success) {
    console.log("Export completed successfully");
    ElNotification.success({ message: "Export completed!" });
  } else {
    console.error("Export failed");
    ElNotification.error({ message: "Export failed!" });
  }
};

// Sample Data
const fundsData = computed(() => {
  const funds = {};

  // Process all transactions
  transactions.value.forEach((transaction) => {
    const fundName = transaction.fund || "Uncategorized";

    // Initialize fund if not exists
    if (!funds[fundName]) {
      funds[fundName] = {
        income: [],
        expense: [],
        incomeTotal: 0,
        expenseTotal: 0,
        balance: 0,
      };
    }

    // Add to appropriate category
    if (transaction.accountCategory === "Income") {
      funds[fundName].income.push(transaction);
      funds[fundName].incomeTotal += transaction.amount;
    } else {
      funds[fundName].expense.push(transaction);
      funds[fundName].expenseTotal += Math.abs(transaction.amount);
    }

    // Calculate balance
    funds[fundName].balance =
      funds[fundName].incomeTotal - funds[fundName].expenseTotal;
  });

  return funds;
});

// Keep your existing computed properties
const groupedTransactions = computed(() => {
  const groups = {};
  transactions.value.forEach((transaction) => {
    if (!groups[transaction.accountCategory]) {
      groups[transaction.accountCategory] = [];
    }
    groups[transaction.accountCategory].push(transaction);
  });
  return groups;
});

const categoryTotals = computed(() => {
  const totals = {};
  for (const category in groupedTransactions.value) {
    totals[category] = groupedTransactions.value[category].reduce(
      (sum, item) => sum + Math.abs(item.amount),
      0
    );
  }
  return totals;
});

const netTotal = computed(() => {
  return (
    (categoryTotals.value["Income"] || 0) -
    (categoryTotals.value["Expense"] || 0)
  );
});

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});

// Computed Totals
const totalExpense = computed(() =>
  incomeStatementData.value &&
  incomeStatementData.value.incomeStatementSummaryByFund
    ? incomeStatementData.value.incomeStatementSummaryByFund.reduce(
        (sum, item) => sum + item.totalExpense,
        0
      )
    : []
);
const totalIncome = computed(() =>
  incomeStatementData.value &&
  incomeStatementData.value.incomeStatementSummaryByFund
    ? incomeStatementData.value.incomeStatementSummaryByFund.reduce(
        (sum, item) => sum + item.totalIncome,
        0
      )
    : []
);
const diffBtwIncomeAndExpenses = computed(() => {
  return totalIncome.value - totalExpense.value;
});

const generateReport = async () => {
  loading.value = true;
  try {
    await getReport();
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const getReport = async () => {
  if (branchItem.value && branchItem.value.id) {
    try {
      const { data } = await axios.get(
        `/api/Reports/financials/getIncomeStatementReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}&branchId=${branchItem.value.id}`
      );
      incomeStatementData.value = data;
      transactions.value = data.transactions.filter((t) => t !== null);
      tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
      incomeStatement.value = data.transactions.filter((i) => i !== null);

      if (incomeStatement.value.length > 0) {
        showReport.value = true;
      } else {
        showReport.value = false;
      }

      chartForIcomeAndExpense.value = data;

      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
      /* End function to call service and populate table */
      loading.value = false;
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      const { data } = await axios.get(
        `/api/Reports/financials/getIncomeStatementReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}`
      );
      incomeStatementData.value = data;
      transactions.value = data.transactions.filter((t) => t !== null);
      tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
      incomeStatement.value = data.transactions.filter((i) => i !== null);

      if (incomeStatement.value.length > 0) {
        showReport.value = true;
      } else {
        showReport.value = false;
      }

      chartForIcomeAndExpense.value = data;

      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
      /* End function to call service and populate table */
      loading.value = false;
    } catch (error) {
      console.log(error);
    }
  }
};
getReport();
const fundChartData = computed(() => {
  if (!incomeStatementData.value?.incomeStatementSummaryByFund) return [];

  // Extract fund names for x-axis categories
  const categories = incomeStatementData.value.incomeStatementSummaryByFund.map(
    (fund) => fund.fundName
  );

  // Prepare series data
  const incomeData = incomeStatementData.value.incomeStatementSummaryByFund.map(
    (fund) => Math.abs(fund.totalIncome)
  );

  const expenseData =
    incomeStatementData.value.incomeStatementSummaryByFund.map((fund) =>
      Math.abs(fund.totalExpense)
    );

  return {
    categories,
    series: [
      {
        name: "Income",
        color: "#4CAF50", // Green for income
        data: incomeData,
      },
      {
        name: "Expense",
        color: "#F44336", // Red for expense
        data: expenseData,
      },
    ],
  };
});
const pieChartData = computed(() => {
  if (!incomeStatementData.value?.incomeStatementSummaryByFund) return [];

  return incomeStatementData.value.incomeStatementSummaryByFund.map((fund) => ({
    name: fund.fundName,
    value: Math.abs(fund.netBalance), // Absolute value for visualization
    color: fund.netBalance >= 0 ? "#4CAF50" : "#F44336", // Green if positive, red if negative
    // actualValue: fund.netBalance // Store original value for display
  }));
});

// Format Amount
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
